// Bidirectional bridge between a lucide-react icon component and the stable
// string name we use to persist user choices (e.g. favourites stored as JSON
// in accounts.favorite_links). The component → name direction relies on the
// React displayName/name; the name → component direction is a `Lucide[name]`
// lookup with a sensible fallback so a renamed/missing icon never crashes a
// render.

import * as Lucide from 'lucide-react';
import { LayoutGrid } from 'lucide-react';

/** lucide component (or already a string) → its display name. */
export function iconName(IconComp) {
  if (!IconComp) return null;
  if (typeof IconComp === 'string') return IconComp;
  return IconComp.displayName || IconComp.name || null;
}

/** stored icon name (or a passed component) → lucide component, with fallback. */
export function resolveIcon(icon) {
  if (!icon) return LayoutGrid;
  if (typeof icon === 'string') return Lucide[icon] || LayoutGrid;
  return icon;
}
